
import { Controller } from "@hotwired/stimulus"

const STATE_ENABLED = "enabled"
const STATE_DISABLED = "disabled"

export default class extends Controller {
  static targets = ["icon", "input"]
  static values = {
    state: Boolean,
    url: String,
    templateId: String,
    paramKey: String,
    attribute: String,
    iconOn: String,
    iconOff: String,
    opposite: Boolean
  }

  connect() {
    this.handleConfirm = this.handleConfirm.bind(this)
    this.refresh()
  }

  toggle(event) {
    event.preventDefault()
    this.pendingState = !this.stateValue
    this.openFacebox()
  }

  change(event) {
    event.preventDefault()
    this.pendingState = event.target.checked
    this.resetInput()
    this.openFacebox()
  }

  populateFacebox() {
    const facebox = $('#facebox:visible')[0];
    if (!facebox) return

    this.toggleFaceboxMessages(facebox, this.pendingState)
    const confirmButton = facebox.querySelector(".toggle-confirm-button")
    confirmButton.disabled = false
    confirmButton.addEventListener("click", this.handleConfirm, { once: true })
  }

  handleConfirm(event) {
    event.preventDefault()
    const targetState = this.pendingState
    $(document).trigger("close.facebox")

    if (typeof targetState === "undefined") return

    mdFormHelper.showSpinner();
    turboStreamHandler.runRequest(this.urlValue, "PATCH", this.payloadFor(targetState))
  }

  refresh() {
    this.updateIcon()
    this.updateTooltip()
  }

  updateIcon() {
    if (!this.hasIconTarget) return

    const iconName = this.stateValue ? this.iconOnValue : this.iconOffValue
    this.iconTarget.textContent = iconName
  }

  updateTooltip() {
    const tooltip = this.tooltipFor(this.stateValue)
    this.element.title = tooltip
    this.element.setAttribute("aria-label", tooltip)
  }

  toggleFaceboxMessages(container, state) {
    const stateKey = state ? STATE_ENABLED : STATE_DISABLED
    container.querySelectorAll(".js-toggle-message").forEach(node => {
      node.classList.toggle("tw-hidden", node.dataset.toggleState !== stateKey)
    })
  }

  tooltipFor(state) {
    const template = document.getElementById(this.templateIdValue)
    if (!template) return ""

    const targetState = state ? STATE_DISABLED : STATE_ENABLED
    const node = template.querySelector(`.js-toggle-tooltip[data-toggle-state='${targetState}']`)
    return node ? node.textContent.trim() : ""
  }

  payloadFor(state) {
    const shouldInvert = this.hasOppositeValue ? this.oppositeValue : false
    const value = shouldInvert ? (state ? 0 : 1) : (state ? 1 : 0)
    return { [this.paramKeyValue]: { [this.attributeValue]: value } }
  }

  openFacebox() {
    window.$(document).one("reveal.facebox", () => this.populateFacebox())
    showFacebox(this.templateIdValue)
  }

  resetInput() {
    if (this.hasInputTarget) {
      this.inputTarget.checked = this.stateValue
    }
  }
}
